let thElm;
let startOffset;

let mouseMoveListener = function(e) {
  if (thElm) {
    thElm.style.width = startOffset + e.pageX + "px";
  }
};

let mouseUpListener = function() {
  thElm = undefined;
};

export default {
  inserted(el) {
    const nodeName = el.nodeName;
    if (["TABLE", "THEAD"].indexOf(nodeName) < 0) return;

    const table = nodeName === "TABLE" ? el : el.parentElement;
    const thead = table.querySelector("thead");
    const ths = thead.querySelectorAll("th");

    table.classList.add("table-resizer");

    ths.forEach(th => {
      th.style.position = "relative";

      var grip = document.createElement("div");
      grip.classList.add("table-resizer-grip");
      grip.innerHTML = "&nbsp;";
      grip.style.top = 0;
      grip.style.right = 0;
      grip.style.bottom = 0;
      grip.style.width = "5px";
      grip.style.position = "absolute";
      grip.style.cursor = "col-resize";
      // grip.style.borderRight = "1px solid #eeeeee";
      grip.addEventListener("mousedown", function(e) {
        thElm = th;
        startOffset = th.offsetWidth - e.pageX;
      });

      th.appendChild(grip);
    });
    document.addEventListener("mousemove", mouseMoveListener);
    document.addEventListener("mouseup", mouseUpListener);
  },
  unbind() {
    document.removeEventListener("mousemove", mouseMoveListener);
    document.removeEventListener("mouseup", mouseUpListener);
  }
};
